module.exports = __webpack_public_path__ + "img/how-03.6e5dbb7c.svg";